import { Box, Typography } from "@mui/material";
import { LitigationArea } from "./Areas";
import { LitigationFunnelMatter } from "../../../api/models/LitigationFunnelMatter";
import { Stage } from "./Stage";

interface Props {
  area: LitigationArea;
  matters: LitigationFunnelMatter[];
}

export const Area = ({ area, matters }: Props) => {
  return (
    <Box sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
      <Typography variant="h6" gutterBottom sx={{whiteSpace: 'nowrap'}}>
        {area.name}
      </Typography>
      <Box sx={{ display: "flex", gap: 1, flex: 1, overflowY: 'auto' }}>
        {area.stages.map((stage) => (
          <Stage
            key={stage.name}
            stage={stage}
            matters={matters.filter((m) => m.stage === stage.stage)}
          />
        ))}
      </Box>
    </Box>
  );
};
